import {SkuskyByDate} from './SkuskyByDate';
import {Skuska} from './skuska';

export class SkuskyList {
  skusky: SkuskyByDate[] = [];

  add(s: Skuska) {
    const skuskyByDate = this.skusky.find(i => i.datum === s.datumSk);

    if (skuskyByDate) {
      skuskyByDate.skusky.push(s);
    }
    else {
      this.skusky.push(new SkuskyByDate(s));
    }
  }
}
